import { legacy_createStore, combineReducers, applyMiddleware } from "redux";
import { userAuth } from "./Auth/user.reducer";
import { appReducer } from "./App/reducer";
import { prodReducer } from "./ProductController/reducer";
import { ProductCart } from "../reducers/index";
import thunk from "redux-thunk";
import startTokenRefreshTimer from "./Auth/authMiddleware";

const rootReducer = combineReducers({
  userAuth,
  appReducer,
  prodReducer,
  ProductCart,
});

const store = legacy_createStore(rootReducer, applyMiddleware(thunk));
startTokenRefreshTimer(store);
export { store };
